/**
 * Ask about this (TMMAPP-0151 §B): the route state a Money Tools page hands the assistant page — the
 * page's suggested question, which only fills the composer. Nothing is sent until the person sends it.
 */

interface AskRouteState {
  askAboutDraft: string;
}

/** The state to navigate with: the composer starts with `text`. */
export function askRouteState(text: string): AskRouteState {
  return { askAboutDraft: text };
}

/** The suggested question a navigation carried, else null. */
export function askedDraftOf(state: unknown): string | null {
  if (typeof state !== 'object' || state === null) return null;
  const draft = (state as Partial<AskRouteState>).askAboutDraft;
  return typeof draft === 'string' && draft.length > 0 ? draft : null;
}
